module.exports = __webpack_public_path__ + "static/media/generator.112ae1f6.png";